import React from "react";
import PropTypes from "prop-types";

import Menu from "@material-ui/core/Menu/Menu";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import IconButton from "@material-ui/core/IconButton/IconButton";
import DotsMenu from "@material-ui/icons/MoreVert";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";

import * as GBConst from "../NonComponents/GBConst";
import { getModAbbr } from "../NonComponents/GBUtil";

import TButton from "../../../Library/Buttons/TButton";
import TDialog from "../../../Library/Dialogs/TDialog";

import * as Theme from "../../../App/Theme";
import HelpIcon from "../../../Img/DM/Help 32 n p.png";

import { RESTService } from "../../../API/server_calls";

const signInMenuItem = 1;
const resourcesMenuItem = 2;
const contactUsMenuItem = 3;
const switchToolMenuItem = 4;
const helpMenuItem = 5;

class GBAppBarCustom extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        handleManageAccount: PropTypes.func,
        handleSignOut: PropTypes.func,
        onHelpClick: PropTypes.func,
        humanName: PropTypes.string,
        isGuest: PropTypes.bool,
        onModuleChange: PropTypes.func,
        onPageChange: PropTypes.func,
        selectedModID: PropTypes.number,
        signedIn: PropTypes.bool,
    };

    static defaultProps = {
        handleManageAccount: () => console.log("handleManageAccount"),
        handleSignOut: () => console.log("handleSignOut"),
        onHelpClick: () => console.log("onHelpClick"),
        humanName: "",
        isGuest: "false",
        onModuleChange: () => console.log("onModuleChange"),
        onPageChange: () => console.log("onPageChange"),
        signedIn: "false",
        selectedModID: GBConst.GB_GB,
    };

    state = {
        fileAnchor: null,
        showContactUsDialogBool: false,
        showVersionDialogBool: false,
        serverVersion: 0.0,
        serverVersionDate: 0,
        windowInnerWidth: 0,
    };

    //==================================================================================================================
    //
    //                                             Life Cycle Events
    //
    //==================================================================================================================

    componentDidMount() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
        this.fetchServerVersion(); // Fetch the server version when the component mounts
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onPageChange = (id) => {
        try {
            this.props.onPageChange(id);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onUserGuideClick = () => {
        try {
            const selectedModID = this.props.selectedModID;

            switch (selectedModID) {
                case GBConst.GB_SC:
                    window.open("./ResourcesSC.html", "_blank");
                    //window.location = "ResourcesSC.html";
                    break;

                case GBConst.GB_DM:
                    window.open("./ResourcesDM.html", "_blank");
                    //window.location = "ResourcesDM.html";
                    break;

                default:
                    break;
            }
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onHelpBtnClick = () => {
        try {
            this.props.onHelpClick();
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    /* By making the inner width state and setting it when the screen resizes, we can update the app bar controls
       based on the width of the screen. */
    onResize = () => {
        this.setState({
            fileAnchor: null,
            windowInnerWidth: window.innerWidth,
        });
    };

    handleFileBtnClick = (event) => {
        this.setState({
            fileAnchor: event.currentTarget,
        });
    };

    handleFileBtnClose = () => {
        this.setState({
            fileAnchor: null,
        });
    };

    onDotMenuItemClick = (menuItemByte) => {
        try {
            const props = this.props;
            const onModuleChange = props.onModuleChange;
            const selectedModID = props.selectedModID;

            this.setState(
                {
                    fileAnchor: null,
                },
                () => {
                    switch (menuItemByte) {
                        case signInMenuItem:
                            this.onPageChange(GBConst.GBLoginFormPg);
                            break;

                        case resourcesMenuItem:
                            this.onUserGuideClick();
                            break;

                        case contactUsMenuItem:
                            this.onContactUsBtnClick();
                            break;

                        case switchToolMenuItem:
                            if (selectedModID === GBConst.GB_SC) {
                                onModuleChange(GBConst.GB_DM);
                            } else {
                                onModuleChange(GBConst.GB_SC);
                            }

                            break;

                        case helpMenuItem:
                            this.onHelpBtnClick();
                            break;

                        default:
                            break;
                    }
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onContactUsBtnClick = () => {
        this.setState({
            showContactUsDialogBool: !this.state.showContactUsDialogBool,
        });
    };

    onVersionBtnClick = () => {
        this.setState({
            showVersionDialogBool: !this.state.showVersionDialogBool,
        });
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderContactUsDialog = () => {
        try {
            let dialog = null;

            /* state */
            const state = this.state;
            const showContactUsDialogBool = state.showContactUsDialogBool;

            if (showContactUsDialogBool) {
                const contactUsLab = (
                    <p
                        style={{
                            color: Theme.blackColor,
                            display: "block",
                            fontSize: 24,
                            fontWeight: "bold",
                            marginBottom: 20,
                            marginTop: 0,
                        }}
                    >
                        {"Contact us"}
                    </p>
                );

                const divider = (
                    <Divider
                        style={{
                            color: Theme.grayColor,
                        }}
                    />
                );

                const contactUsLink = (
                    <p>
                        {"Questions or comments? We can be reached at the following email address"}:<br></br>
                        <Link
                            href={"mailto:vmmc-avenir@googlegroups.com"}
                            style={{
                                color: Theme.primaryColor,
                                cursor: "pointer",
                            }}
                            underline={"hover"}
                        >
                            {"VMMC-Avenir@GoogleGroups.com"}
                        </Link>
                        <br></br>
                        <br></br>
                        {"For help with data preparation and upload, please visit the following link: "}
                        <Link
                            href={"resources/DM/download/DMPPT2%20Data%20Preparation%20&%20Upload.pdf"}
                            target={"_blank"}
                            style={{
                                color: Theme.primaryColor,
                                cursor: "pointer",
                            }}
                            underline={"hover"}
                        >
                            {"Data Preparation & Upload"}
                        </Link>
                    </p>
                );

                let dialogContent = [];
                dialogContent.push(contactUsLab);
                dialogContent.push(divider);
                dialogContent.push(contactUsLink);

                dialog = (
                    <TDialog
                        actions={["mrClose"]}
                        closeBtnCaption={"CLOSE"}
                        onClose={this.onContactUsBtnClick}
                        content={dialogContent}
                        visible={true}
                    />
                );
            }

            return dialog;
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
            return null;
        }
    };

    renderVersionDialog = () => {
        try {
            const { showVersionDialogBool, serverVersion, serverVersionDate } = this.state;

            if (!showVersionDialogBool) return null;

            const clientVersion = GBConst.GB_VersionNum;

            // Create the dialog content
            const versionLab = (
                <p
                    style={{
                        color: Theme.blackColor,
                        display: "block",
                        fontSize: 24,
                        fontWeight: "bold",
                        marginBottom: 20,
                        marginTop: 0,
                    }}
                >
                    {"Version Information"}
                </p>
            );

            const divider = (
                <Divider
                    style={{
                        color: Theme.grayColor,
                    }}
                />
            );

            function getServerVersionName() {
                switch (window.API_URL_BASE) {
                    case GBConst.GB_BetaServerURL:
                        return "2025 Beta";
                    case GBConst.GB_Beta2024ServerURL:
                        return "2024 Beta";
                    case GBConst.GB_LiveServerURL:
                        return "2025 Live";
                    case GBConst.GB_Live2024ServerURL:
                        return "2024 Live";
                    case GBConst.GB_LocalhostServerURL:
                        return "Running locally";
                    default:
                        return "Unknown Server Version";
                }
            }

            const versionInfo = (
                <div
                    style={{
                        fontSize: 18,
                        color: Theme.blackColor,
                    }}
                >
                    {/* Add Two Line Breaks Above Client Version */}
                    <div style={{ marginBottom: "20px" }}></div>

                    {/* Client Version Section */}
                    <div>
                        <div>
                            <strong>Client Version:</strong> {clientVersion}
                        </div>
                        <div style={{ marginLeft: "20px" }}>{GBConst.GB_VersionName}</div>
                        <div style={{ marginLeft: "20px" }}>released {GBConst.GB_VersionDate}</div>
                    </div>

                    {/* Spacer Between Sections */}
                    <div style={{ marginBottom: "20px" }}></div>

                    {/* Server Version Section */}
                    <div>
                        <div>
                            <strong>Server Version:</strong> {serverVersion || "Loading..."}
                        </div>
                        <div style={{ marginLeft: "20px" }}>{getServerVersionName()}</div>
                        <div style={{ marginLeft: "20px" }}>released {serverVersionDate || "Loading..."}</div>
                    </div>
                </div>
            );

            let dialogContent = [];
            dialogContent.push(versionLab);
            dialogContent.push(divider);
            dialogContent.push(versionInfo);

            return (
                <TDialog
                    actions={["mrClose"]}
                    closeBtnCaption={"CLOSE"}
                    onClose={this.onVersionBtnClick}
                    content={dialogContent}
                    visible={true}
                />
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
            return null;
        }
    };

    fetchServerVersion = () => {
        RESTService.getVersion(
            (response) => {
                const serverVersion = response.version || "Unknown";
                const serverVersionDate = response.versionDate || "Unknown";
                this.setState({ serverVersion, serverVersionDate }); // Update state with the server version
            },
            (error) => {
                console.error("Error fetching server version:", error);
                this.setState({ serverVersion: "Error fetching version" }); // Handle error
            }
        );
    };

    render() {
        try {
            const props = this.props;
            const handleManageAccount = props.handleManageAccount;
            const handleSignOut = props.handleSignOut;
            const humanName = props.humanName;
            const isGuest = props.isGuest;
            const onModuleChange = props.onModuleChange;
            const selectedModID = props.selectedModID;

            /* State */
            const state = this.state;
            const fileAnchor = state.fileAnchor;
            const windowInnerWidth = state.windowInnerWidth;

            /* The following button widths are determines by hitting F12 in Chrome and using the
               element selector to see what the widths are, including the divs they are on.
               Widths change depending on modes and various options, so construct them.

               Give some extra space for the app title. */
            let appTitleLabWidth;
            let resourcesBtnWidth;
            let switchToolBtnWidth;
            let helpBtnWidth;

            if (selectedModID === GBConst.GB_SC) {
                appTitleLabWidth = 690;
                resourcesBtnWidth = 139;
                switchToolBtnWidth = 197;
                helpBtnWidth = 0;
            } else if (selectedModID === GBConst.GB_DM) {
                appTitleLabWidth = 660;
                resourcesBtnWidth = 139;
                switchToolBtnWidth = 176;
                helpBtnWidth = 32;
            }
            // GB / Welcome screen, before choosing SC or DM
            else {
                appTitleLabWidth = 450;
                resourcesBtnWidth = 0;
                switchToolBtnWidth = 0;
                helpBtnWidth = 0;
            }

            /* Will vary depending on user's name. */
            const nameLabWidth = 220;

            const signInBtnWidth = 104;

            const contactUsBtnWidth = 133;

            const versionBtnWidth = 133;

            const dotsBtnWidth = 48;

            const rightMarginWidth = 25; // space to the right of the buttons

            let totalPixels = appTitleLabWidth + nameLabWidth + signInBtnWidth + rightMarginWidth;
            const signInBtnHideWidth = totalPixels;

            totalPixels += contactUsBtnWidth;
            const contactUsBtnHideWidth = totalPixels;

            totalPixels += resourcesBtnWidth;
            const resourcesBtnHideWidth = totalPixels;

            totalPixels += switchToolBtnWidth;
            const switchToolBtnHideWidth = totalPixels;

            totalPixels += helpBtnWidth;
            const helpBtnHideWidth = totalPixels;

            totalPixels += versionBtnWidth;
            const versionBtnHideWidth = totalPixels;

            const rightmostBtnHideWidth = versionBtnHideWidth;

            let signInBtn = null;
            let signInMenuItemComp = null;
            let resourcesBtn = null;
            let resourcesMenuItemComp = null;
            let contactUsBtn = null;
            let contactUsMenuItemComp = null;
            let switchToolBtn = null;
            let switchToolMenuItemComp = null;
            let helpBtn = null;
            let helpMenuItemComp = null;
            let versionBtn = null;
            let versionMenuItemComp = null;
            let dotsMenuDiv = null;

            /* whiteSpace nowrap prevents appbar height from changing */

            const nameLabel = (
                <p
                    style={{
                        color: Theme.whiteColor,
                        fontFamily: Theme.fontFamily,
                        fontSize: 16,
                        marginLeft: 20,
                        marginRight: 20,
                    }}
                >
                    {/* {"Welcome, " + (humanName === "" ? "Guest" : humanName)} */}
                    {"Welcome"}
                </p>
            );

            let signInOutEvent = null;

            if (isGuest) {
                signInOutEvent = () => this.onPageChange(GBConst.GBLoginFormPg);
            } else {
                signInOutEvent = handleSignOut;
            }

            // if (windowInnerWidth > signInBtnHideWidth) {
            //     signInBtn = (
            //         <TButton
            //             caption={isGuest ? "Sign in" : "Log out"}
            //             captionStyles={{
            //                 color: Theme.whiteColor,
            //                 fontFamily: Theme.fontFamily,
            //                 fontSize: 16,
            //                 textDecoration: "underline",
            //             }}
            //             key={"signInBtn"}
            //             transparent={true}
            //             containerStyle={{
            //                 display: "inline-block",
            //             }}
            //             onClick={signInOutEvent}
            //         />
            //     );
            // } else {
            //     signInMenuItemComp = <MenuItem onClick={signInOutEvent}>{isGuest ? "Sign in" : "Log out"}</MenuItem>;
            // }

            if (windowInnerWidth > contactUsBtnHideWidth) {
                contactUsBtn = (
                    <TButton
                        caption={"Contact us"}
                        captionStyles={{
                            color: Theme.whiteColor,
                            fontFamily: Theme.fontFamily,
                            fontSize: 16,
                            textDecoration: "underline",
                        }}
                        key={"contactUsBtn"}
                        transparent={true}
                        containerStyle={{
                            display: "inline-block",
                        }}
                        onClick={this.onContactUsBtnClick}
                    />
                );
            } else {
                contactUsMenuItemComp = <MenuItem onClick={this.onContactUsBtnClick}>{"Contact us"}</MenuItem>;
            }

            if (selectedModID === GBConst.GB_SC || selectedModID === GBConst.GB_DM) {
                if (windowInnerWidth > resourcesBtnHideWidth) {
                    resourcesBtn = (
                        <TButton
                            caption={"Resources"}
                            captionStyles={{
                                color: Theme.whiteColor,
                                fontFamily: Theme.fontFamily,
                                fontSize: 16,
                                textDecoration: "underline",
                            }}
                            key={"resourcesBtn"}
                            transparent={true}
                            containerStyle={{
                                display: "inline-block",
                            }}
                            onClick={this.onUserGuideClick}
                        />
                    );
                } else {
                    resourcesMenuItemComp = <MenuItem onClick={this.onUserGuideClick}>{"Resources"}</MenuItem>;
                }

                let switchToMod;

                if (selectedModID === GBConst.GB_SC) {
                    switchToMod = GBConst.GB_DM;
                } else {
                    switchToMod = GBConst.GB_SC;
                }

                if (windowInnerWidth > switchToolBtnHideWidth) {
                    switchToolBtn = (
                        <TButton
                            caption={"Switch to " + getModAbbr(switchToMod)}
                            captionStyles={{
                                color: Theme.whiteColor,
                                fontFamily: Theme.fontFamily,
                                fontSize: 16,
                                textDecoration: "underline",
                            }}
                            key={"switchToolBtn"}
                            transparent={true}
                            containerStyle={{
                                display: "inline-block",
                            }}
                            onClick={() => onModuleChange(switchToMod)}
                        />
                    );
                } else {
                    switchToolMenuItemComp = (
                        <MenuItem onClick={() => onModuleChange(switchToMod)}>
                            {"Switch to " + getModAbbr(switchToMod)}
                        </MenuItem>
                    );
                }
            }

            if (selectedModID === GBConst.GB_DM) {
                if (windowInnerWidth > helpBtnHideWidth) {
                    helpBtn = (
                        <div key={"helpBtnDiv"}>
                            <img
                                alt="" // to avoid hint
                                onClick={this.onHelpBtnClick}
                                key={"helpBtnDivImg"}
                                style={Theme.helpBtnImgStyle}
                                src={HelpIcon}
                            />
                        </div>
                    );
                } else {
                    helpMenuItemComp = <MenuItem onClick={this.onHelpBtnClick}>{"Help"}</MenuItem>;
                }
            }

            if (windowInnerWidth > versionBtnHideWidth) {
                versionBtn = (
                    <TButton
                        caption={"Version"}
                        captionStyles={{
                            color: Theme.whiteColor,
                            fontFamily: Theme.fontFamily,
                            fontSize: 16,
                            textDecoration: "underline",
                        }}
                        key={"versionBtn"}
                        transparent={true}
                        containerStyle={{
                            display: "inline-block",
                        }}
                        onClick={this.onVersionBtnClick}
                    />
                );
            } else {
                versionMenuItemComp = <MenuItem onClick={this.onVersionBtnClick}>{"Version"}</MenuItem>;
            }

            if (windowInnerWidth <= rightmostBtnHideWidth) {
                const dotsMenuBtn = (
                    <IconButton
                        aria-label="Menu"
                        aria-owns={fileAnchor ? "file-menu" : null}
                        aria-haspopup="true"
                        color={"secondary"}
                        onClick={this.handleFileBtnClick}
                    >
                        <DotsMenu />
                    </IconButton>
                );

                const dotsMenu = (
                    <Menu
                        id="file-menu"
                        anchorEl={fileAnchor}
                        open={Boolean(fileAnchor)}
                        onClose={this.handleFileBtnClose}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                    >
                        {signInMenuItemComp}
                        {contactUsMenuItemComp}
                        {resourcesMenuItemComp}
                        {switchToolMenuItemComp}
                        {helpMenuItemComp}
                        {versionMenuItemComp}
                    </Menu>
                );

                dotsMenuDiv = (
                    <div
                        style={{
                            display: "inline-block",
                            float: "right",
                            marginTop: 5,
                        }}
                    >
                        {dotsMenuBtn}
                        {dotsMenu}
                    </div>
                );
            }

            const btnDiv = (
                <div
                    key={"btnDiv"}
                    style={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        float: "right",
                    }}
                >
                    {nameLabel}
                    {signInBtn}
                    {contactUsBtn}
                    {resourcesBtn}
                    {switchToolBtn}
                    {helpBtn}
                    {versionBtn}
                </div>
            );

            const contactUsDialog = this.renderContactUsDialog();
            const versionDialog = this.renderVersionDialog();

            return (
                <div
                    style={{
                        width: "100%",
                    }}
                >
                    {contactUsDialog}
                    {versionDialog}
                    {dotsMenuDiv}
                    {btnDiv}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"GBAppBarCustomDiv"}
                    key={"GBAppBarCustomDiv"}
                >
                    <h3 key={"GBAppBarCustomDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default GBAppBarCustom;
